// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Monday_wrap__3awTT"};